/**
 * API de bonificaciones de cupo WhatsApp (Panel → coofit_core.tenant_whatsapp_bonus).
 */

import { httpClient } from '../http/client/httpClient';

export interface WhatsAppBonusDTO {
  id: number;
  tenantId: string;
  period: string;
  messages: number;
  reason: string;
  scope: 'all' | 'manual_only';
  createdAt: string;
  createdByUserId: number | null;
  createdByName: string | null;
  revokedAt: string | null;
  revokedByUserId: number | null;
  revokedByName: string | null;
  revokeReason: string | null;
}

function apiErrorMessage(err: unknown, fallback: string): Error {
  if (err && typeof err === 'object' && 'response' in err) {
    const data = (err as { response?: { data?: { message?: string } } }).response?.data;
    if (data?.message) return new Error(data.message);
  }
  if (err instanceof Error) return err;
  return new Error(fallback);
}

export async function listWhatsAppBonuses(
  tenantId: string,
  opts?: { period?: string; includeRevoked?: boolean }
): Promise<WhatsAppBonusDTO[]> {
  const params = new URLSearchParams();
  if (opts?.period) params.set('period', opts.period);
  if (opts?.includeRevoked) params.set('includeRevoked', '1');
  const q = params.toString() ? `?${params.toString()}` : '';
  try {
    const response = await httpClient.get<WhatsAppBonusDTO[]>(
      `/whatsapp-bonus/by-tenant/${tenantId}${q}`
    );
    return Array.isArray(response.data) ? response.data : [];
  } catch (err) {
    throw apiErrorMessage(err, 'No se pudieron cargar las bonificaciones');
  }
}

export async function createWhatsAppBonus(
  tenantId: string,
  body: {
    messages: number;
    reason: string;
    period?: string;
    scope?: 'all' | 'manual_only';
  }
): Promise<WhatsAppBonusDTO> {
  try {
    const response = await httpClient.post<WhatsAppBonusDTO>(
      `/whatsapp-bonus/by-tenant/${tenantId}`,
      body
    );
    return response.data;
  } catch (err) {
    throw apiErrorMessage(err, 'No se pudo registrar la bonificación');
  }
}

export async function revokeWhatsAppBonus(
  id: number,
  body: { revokeReason: string }
): Promise<WhatsAppBonusDTO> {
  try {
    const response = await httpClient.post<WhatsAppBonusDTO>(
      `/whatsapp-bonus/${id}/revoke`,
      body
    );
    return response.data;
  } catch (err) {
    throw apiErrorMessage(err, 'No se pudo anular la bonificación');
  }
}
